import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom"; 
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getBaseUrl } from "../utils";

const Blog = () => {
    const navigate = useNavigate(); 
    const [blog_Data, setBlogData] = useState([]);

    const blogData = async () => {
        try {
            const response = await axios.get(`${getBaseUrl()}user_api/blogData`);
            if (response.data && response.data.results) {
                setBlogData(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching Blog Data:", error);
        }
    };

    useEffect(() => {
        blogData(); 
    }, []);

    const handleTabClick = (blogData) => {
        navigate('/BlogDeatils', { state: { blogData: blogData } });
    };

    return (
        <div>
            <Navbar />


            {/* new add  */}
            <section className="bg-[#F2F2F2] pt-[50px] pb-[10px] mt-20 md:px-0 px-2">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-sm-6 p-0 m-0">
                            <div className="pr-[10px] pt-[10px] pb-[10px]">
                            <h5 className="text-[#868686] Paragraph__etxt font-[500] pb-[10px]" style={{fontSize:'22px'}}>Our Recommendation for you</h5>
                            <h3 className="Paragraph__etxt pb-[16px] font-[800]" style={{fontSize:'40px'}}>RECOMMENDED</h3>
                            <h6 className="Paragraph__etxt font-[500] pb-[8px]" style={{fontSize:'22px'}}>Mr Guru.in</h6>
                            <h4 className="Header__text font-[700] pb-1">
                                How to Create a Study Schedule That Works for
                                you.
                            </h4>
                            <p className="Paragraph__etxt pb-[17px]">
                                Creating an effective study schedule is key to
                                managing your time and boosting productivity. In
                                this blog, we’ll show you how to design a
                                personalized schedule that fits your needs,
                                helps you stay....
                            </p>
                            <label className="border-b Paragraph__etxt font-[700]" style={{fontSize:'20px'}}>Read More</label>
                            </div>
                        </div>

                        <div className="col-sm-6 p-0 m-0">
                            <img src="/assates/Blog__images.png" alt="images" />
                        </div>
                    </div>
                </div>
            </section>

            {/* new add */}
            <section className="bg-[#F2F2F2] pt-[50px] pb-[10px]">
                <div className="container-xxl">
                    <div className="row">
                        {blog_Data.map((item, index) => (
                            <div
                                className="col-md-4 pb-[20px] pl-[10px] pr-[15px]"
                                key={index}
                            >
                                <div className="rounded-[15px]" onClick={() => handleTabClick(item)}>
                                    <div>
                                        <div className="images">
                                            <img
                                                src={item.image}
                                                alt="images"
                                                className="rounded-lg"
                                            />
                                        </div>
                                        <div className="text">
                                            <h4 className="Header__text font-[700] pt-[15px] pb-[5px]" style={{ fontSize: "18px" }}>
                                                {item.name}
                                            </h4>
                                            <div className="Paragraph__etxt pb-6 pb-[15px]">
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.description.slice(0, 100) + "...",
                                                    }}
                                                />
                                            </div>
                                            <Link to="#">
                                                <label
                                                    className="Header__text font-[700] flex itemns-center"
                                                    style={{ fontSize: "18px" }}
                                                >
                                                    {item.link} {item.icons}
                                                </label>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Blog;
